import script from "./UserTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTable.vue?vue&type=script&setup=true&lang=js"

import "./UserTable.vue?vue&type=style&index=0&id=796a523a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796a523a"]])

export default __exports__